export const MAX_RESUMABLE_FILE_BYTES = Number.MAX_SAFE_INTEGER;
export const MAX_UPLOAD_SIZE_MB = Math.floor(MAX_RESUMABLE_FILE_BYTES / (1024 * 1024));
export const DEFAULT_UPLOAD_LIMIT_MB = 20 * 1024;
export const ATTACH_CHUNK_BYTES = 8 * 1024 * 1024;
export const ATTACH_RESUMABLE_PATH = "/api/attach/resumable";
export const ATTACH_UPLOAD_TTL_MS = 24 * 60 * 60 * 1000;
